import { render, staticRenderFns } from "./FunnelItem.vue?vue&type=template&id=53d0d14e&scoped=true&"
import script from "./FunnelItem.vue?vue&type=script&lang=js&"
export * from "./FunnelItem.vue?vue&type=script&lang=js&"
import style0 from "./FunnelItem.vue?vue&type=style&index=0&id=53d0d14e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d0d14e",
  null
  
)

export default component.exports